import Model from '@/class/cargo/model/utils/Model'
/**
 * ChargeMeasure 常量
 */

export class ChargeMeasure {
  constructor(code, englishName, chineseName, forSeaFreight, forAirFreight) {
    this.code = code
    this.chineseName = chineseName
    this.englishName = englishName
    this.forSeaFreight = forSeaFreight
    this.forAirFreight = forAirFreight
  }
}
export const CODE_NAME = 'ChargeMeasure'

export const NML_CHARGE_MEASURE = new ChargeMeasure('NML', 'Normal', '普通价', true, true)
export const WGT_CHARGE_MEASURE = new ChargeMeasure('WGT', 'Weight', '重量价', true, true)
export const WGTT_CHARGE_MEASURE = new ChargeMeasure('WGTT', 'Weight(/T)', '重量价（吨）', true, true)
export const WGTX_CHARGE_MEASURE = new ChargeMeasure('WGTX', 'Charge Weight', '计费重量价', true, true)
export const VOL_CHARGE_MEASURE = new ChargeMeasure('VOL', 'Volume', '体积价', true, true)
export const MIN_CHARGE_MEASURE = new ChargeMeasure('MIN', 'Minimum', '最低价', false, true)
export const C20_CHARGE_MEASURE = new ChargeMeasure('C20', "20'", "20'", true, false)
export const C40_CHARGE_MEASURE = new ChargeMeasure('C40', "40'", "40'", true, false)
export const C40H_CHARGE_MEASURE = new ChargeMeasure('C40H', "40'HC", "40'HC", true, false)
export const C45_CHARGE_MEASURE = new ChargeMeasure('C45', "45'HC", "45'HC", true, false)
export const W45_CHARGE_MEASURE = new ChargeMeasure('W45', '+45', '+45', false, true)
export const W100_CHARGE_MEASURE = new ChargeMeasure('W100', '+100', '+100', false, true)
export const W300_CHARGE_MEASURE = new ChargeMeasure('W300', '+300', '+300', false, true)
export const W500_CHARGE_MEASURE = new ChargeMeasure('W500', '+500', '+500', false, true)
export const W1000_CHARGE_MEASURE = new ChargeMeasure('W1000', '+1000', '+1000', false, true)
export const FSC_CHARGE_MEASURE = new ChargeMeasure('FSC', 'FSC', 'FSC', false, true)
export const SSC_CHARGE_MEASURE = new ChargeMeasure('SSC', 'SSC', 'SSC', false, true)
export const BL_CHARGE_MEASURE = new ChargeMeasure('BL', 'Per B/L', '提单', true, true)
export const CNTR_CHARGE_MEASURE = new ChargeMeasure('CNTR', 'Per CNTR', '箱数', true, true)
export const BY_CNTR_CHARGE_MEASURE = new ChargeMeasure('BYCNTR', 'ByCNTR', '按箱型', true, true)
export const SHIPMENT_CHARGE_MEASURE = new ChargeMeasure('SHIPMENT', 'Per Shipment', '票', true, true)
export const PIECE_CHARGE_MEASURE = new ChargeMeasure('PIECE', 'Per Piece', '件', true, true)
export const BOX_MEASURE = new ChargeMeasure('BOX', 'Box Tube', '箱价,箱使费', true, true)
export const SONO_MEASURE = new ChargeMeasure('SONO', 'SONO', '关单号', true, true)
export const ZYCS_MEASURE = new ChargeMeasure('ZYCS', 'ZYCS', '最远城市', true, true)
export const TPS_MEASURE = new ChargeMeasure('TPS', 'TPS', '托盘数', true, true)
export const MDS_MEASURE = new ChargeMeasure('MDS', 'MDS', '门点数', true, true)

export const C20FR_CHARGE_MEASURE = new ChargeMeasure('20FR', "20'FR", "20'FR", true, true)
export const C40FR_CHARGE_MEASURE = new ChargeMeasure('40FR', "40'FR", "40'FR", true, true)
export const C20T_CHARGE_MEASURE = new ChargeMeasure('20T', "20'OT", "20'OT", true, true)
export const C4OT_CHARGE_MEASURE = new ChargeMeasure('4OT', "40'OT", "40'OT", true, true)
export const C20GP_CHARGE_MEASURE = new ChargeMeasure('20GP', '20GP', '20GP', true, true)
export const VEHICLE_CHARGE_MEASURE = new ChargeMeasure('vehicle', 'VEHICLE', '辆', true, true)
export const DAY_CHARGE_MEASURE = new ChargeMeasure('day', 'DAY', '天', true, true)
export const PO_CHARGE_MEASURE = new ChargeMeasure('po', 'PO', 'PO', true, false)
export const CUSTOMSDECLARATION_CHARGE_MEASURE = new ChargeMeasure('customs', 'CUSTOMS DECLARATION', '报关', true, false)
export const SONO_CHARGE_MEASURE = new ChargeMeasure('SONO', 'SONO', '关单号', true, true)

export const INSIDEPIECE_CHARGE_MEASURE = new ChargeMeasure('XJS', 'Inside Piece', '小件数', true, false)

/**
		 * 费用方案使用
		 */
export const CHARGE_MEASURES_SCHEME = [BY_CNTR_CHARGE_MEASURE, NML_CHARGE_MEASURE, WGT_CHARGE_MEASURE, WGTT_CHARGE_MEASURE,
  WGTX_CHARGE_MEASURE, VOL_CHARGE_MEASURE, MIN_CHARGE_MEASURE, BL_CHARGE_MEASURE, CNTR_CHARGE_MEASURE,
  SHIPMENT_CHARGE_MEASURE, PIECE_CHARGE_MEASURE, W45_CHARGE_MEASURE, W100_CHARGE_MEASURE, W300_CHARGE_MEASURE,
  W500_CHARGE_MEASURE, W1000_CHARGE_MEASURE, FSC_CHARGE_MEASURE, SSC_CHARGE_MEASURE, BOX_MEASURE]

/**
		 * 费用计费单位使用
		 */
export const CHARGE_MEASURES = [NML_CHARGE_MEASURE, WGT_CHARGE_MEASURE, WGTT_CHARGE_MEASURE, WGTX_CHARGE_MEASURE, VOL_CHARGE_MEASURE, MIN_CHARGE_MEASURE,
  BL_CHARGE_MEASURE, CNTR_CHARGE_MEASURE, SHIPMENT_CHARGE_MEASURE, PIECE_CHARGE_MEASURE,
  C20_CHARGE_MEASURE, C40_CHARGE_MEASURE, C40H_CHARGE_MEASURE, C45_CHARGE_MEASURE, W45_CHARGE_MEASURE, W100_CHARGE_MEASURE,
  W300_CHARGE_MEASURE, W500_CHARGE_MEASURE, W1000_CHARGE_MEASURE, FSC_CHARGE_MEASURE, SSC_CHARGE_MEASURE, BOX_MEASURE,
  C20FR_CHARGE_MEASURE, C40FR_CHARGE_MEASURE, C20T_CHARGE_MEASURE, C4OT_CHARGE_MEASURE, C20GP_CHARGE_MEASURE, VEHICLE_CHARGE_MEASURE, DAY_CHARGE_MEASURE,
  PO_CHARGE_MEASURE, CUSTOMSDECLARATION_CHARGE_MEASURE, SONO_CHARGE_MEASURE
]

/**
 * 费用计费单位使用
 */
export const ALL_CHARGE_MEASURES = [BY_CNTR_CHARGE_MEASURE, NML_CHARGE_MEASURE, WGT_CHARGE_MEASURE, WGTT_CHARGE_MEASURE, WGTX_CHARGE_MEASURE, VOL_CHARGE_MEASURE, MIN_CHARGE_MEASURE,
  BL_CHARGE_MEASURE, CNTR_CHARGE_MEASURE, SHIPMENT_CHARGE_MEASURE, PIECE_CHARGE_MEASURE,
  C20_CHARGE_MEASURE, C40_CHARGE_MEASURE, C40H_CHARGE_MEASURE, C45_CHARGE_MEASURE, W45_CHARGE_MEASURE, W100_CHARGE_MEASURE,
  W300_CHARGE_MEASURE, W500_CHARGE_MEASURE, W1000_CHARGE_MEASURE, FSC_CHARGE_MEASURE, SSC_CHARGE_MEASURE, BOX_MEASURE,
  C20FR_CHARGE_MEASURE, C40FR_CHARGE_MEASURE, C20T_CHARGE_MEASURE, C4OT_CHARGE_MEASURE, C20GP_CHARGE_MEASURE, VEHICLE_CHARGE_MEASURE, DAY_CHARGE_MEASURE,
  PO_CHARGE_MEASURE, CUSTOMSDECLARATION_CHARGE_MEASURE, ZYCS_MEASURE, TPS_MEASURE, MDS_MEASURE, SONO_CHARGE_MEASURE
]

/**
 *  return null:没找到.
 */
export function getChargeMeasureByCode(code) {
  return Model.getObjByCode(code, ALL_CHARGE_MEASURES)
}
